define( function() {

	// Match a standalone tag
	return ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
} );



//////////////////
// WEBPACK FOOTER
// /~/jquery/src/core/var/rsingleTag.js
// module id = 858
// module chunks = 0